import React from 'react'
import SnackBar from 'components/SnackBar'
import utils from '../../Utils'
import axios from 'axios'
import Header from '../Header'
import RateBox from './RateBox'
import Comments from '../comments'
import ConsultRequestButton from './ConsultRequestButton'
import 'style/consult/NewConsult.css'
import { Redirect } from 'react-router-dom'
import Matrix from 'scripts/Matrix'
// import CallModal from '../CallModal'

class DoctorProfile extends React.Component {
    state = {
        redirect: '',
        laoding: false,
        consultRating: {},
        data: null,
        number: ''
    }

    async componentDidMount() {
        await this.apiGetDoctorInfo()
        if (!window.localStorage.token)
            window.localStorage.setItem('doctorProfile', window.location.pathname.split('/')[2])
        else
            window.localStorage.removeItem('doctorProfile')
        // if (this.state.data.DoctorConsultInfo.callStatus) this.getCallRequest()
    }

    apiGetDoctorInfo = async () => {
        this.setState({ loading: true })

        let res = await axios.get(utils.urls.doctorUrl(this.props.match.params.doctorId))
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            });

        if (!res) return

        let { success } = res.data;
        if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
        this.setState({
            data: res.data.doctor,
            consultRating: res.data.consultRating[0]
        })

        this.setState({ loading: false })
    }

    openSnackbar = (msg, type) => this.SnackBar.openSnackbar(msg, type)

    onClickConsultRequestButton = () => {
        console.log('tag manager', 'on click consult request button')
        utils.sendGtmEvent('Convert', 'D Page - Request')
        this.setState({ redirect: { pathname: '/consult/new', state: { doctor: this.state.data, type: 'text' } } })
    }

    render() {
        const { data, consultRating, redirect } = this.state

        if (redirect) return <Redirect to={redirect} push />

        return (
            data &&
            <>
                {redirect && <Redirect to={redirect} push />}

                <SnackBar ref={el => { this.SnackBar = el }} />
                { /*<CallModal
                    ref={el => this.CallModal = el}
                    price={data.DoctorConsultInfo.voicePrice}
                    openSnackbar={this.openSnackbar}
                    doctorId={this.state.data.id}
                /> */}
                <Header title="درخواست مشاوره" showBackButton={true} desc={this.state.headerDesc} />
                <div className="page-root">
                    <div className="doctor-profile">
                        <div className="card doctor-info-container">
                            <div className="doctor-info__avatar">
                                {data.url ?
                                    <img src={utils.urls.image + data.url} alt={data.url} /> :
                                    <img src="/images/person.svg" />
                                }
                            </div>
                            <div className="doctor-details" >
                                <div className="doctor-details__name">
                                    <div>{`${data.fname} ${data.lname}`}</div>
                                    <div style={{ fontSize: '10px' }}>
                                        {data.expUnis[0] ?
                                            data.expUnis[0].expertise.name :
                                            data.spUnis[0] ?
                                                data.spUnis[0].specialty.name : ''}
                                    </div>
                                    <div className="avg-response">میانگین زمان پاسخ دهی: <span className="rate">{data.DoctorConsultInfo.avgResponse.toLocaleString("fa-IR")} ساعت</span></div>
                                </div>
                                <RateBox rateItem={consultRating} />
                            </div>
                        </div>
                        <div className="doctor-profile__description">
                            {data.DoctorConsultInfo.textStatus && <ConsultRequestButton
                                onClick={this.onClickConsultRequestButton}
                                title="درخواست مشاوره متنی"
                                subTitle="پاسخ در اسرع وقت توسط پزشک"
                                price={data.DoctorConsultInfo.price}
                                btnText='ثبت درخواست'
                            />
                            }
                            {data.DoctorConsultInfo.voiceStatus &&
                                // href={`tel: ${this.state.number}`}
                                <ConsultRequestButton
                                    // onClick={() => this.CallModal.openModal()}
                                    onClick={() => this.setState({ redirect: { pathname: '/consult/new', state: { voiceConsult: true, doctor: data, type: 'voice' } } })}
                                    title="درخواست مشاوره تلفنی"
                                    subTitle="تماس تلفنی با پزشک"
                                    price={data.DoctorConsultInfo.voicePrice}
                                    btnText="تماس با پزشک"
                                />
                            }
                            {data.DoctorConsultInfo.videoStatus &&
                                // href={`tel: ${this.state.number}`}
                                <ConsultRequestButton
                                    // onClick={() => this.CallModal.openModal()}
                                    onClick={() => this.setState({ redirect: { pathname: '/consult/new', state: { voiceConsult: true, doctor: data, type: 'video' } } })}
                                    title="درخواست مشاوره ویدئویی"
                                    subTitle="تماس تصویری با پزشک"
                                    price={data.DoctorConsultInfo.videoPrice}
                                    btnText="ثبت درخواست"
                                />
                            }
                            <div className="card doctor-profile__education">
                                <div className="card-title">
                                    <div className="card-indicator"></div>
                                       تحصیلات
                                </div>
                                {data.university && <div>
                                    <div className="card-title">عمومی</div>
                                    <p>{data.university && data.university.name}</p>
                                </div>}
                                {data.spUnis.length > 0 &&
                                    <div>
                                        <div className="card-title">تخصص</div>
                                        {data.spUnis.map(item =>
                                            item.university ?
                                                <li key={item.id}>{item.specialty.name + ' - ' + item.university.name}</li> :
                                                <li key={item.id}>{item.specialty.name}</li>
                                        )}
                                    </div>
                                }
                                {data.expUnis.length > 0 &&
                                    <div>
                                        <div className="card-title">فوق تخصص</div>
                                        {data.expUnis.map(item =>
                                            item.university ?
                                                <li key={item.id}>{item.expertise.name + ' - ' + item.university.name}</li> :
                                                <li key={item.id}>{item.expertise.name}</li>
                                        )}
                                    </div>
                                }
                            </div>
                            <div className="card doctor-profile__about">
                                <div className="card-title">
                                    <div className="card-indicator"></div>
                                        درباره
                                </div>
                                <p>{data.about}</p>
                            </div>
                            <Comments snackbar={this.SnackBar} doctorId={data.id} />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default DoctorProfile
